export const PATH = {
  PAGE_404: "/404",
  ROOT: "/",
  HOME: "/home",
  PROFILE: "/profile",
  LOGIN: "/login",
  ADMINDASH: "/admin/dashboard",
  DASH: "/dashboard",
  VALIDATOR_DASH: "/cv/dashboard",
  TS: "/ts",
  ADD_TS: "/ts/add",
  EDIT_TS: "/ts/edit",
  ADD_TS_IMAGES: "/ts/upload-images",
  SERIES_VIEW: "/series/view",
  TEST_ADD: "/test/add",
  TESTS: "/tests",
  TEST_VIEW: "/test/view",
  TEST_EDIT: "/test/edit",
  QUES_ADD: "/home/qb/add",
  QUES_ADD_V: "/home/qb/add-variant",
  QUES_LIST: "/home/qb/list",
  QUES_VIEW: "/home/qb/detail",
  QUES_VIEW_V: "/home/qb/detail_v",
  QUES_EDIT: "/home/qb/edit",
  CONTENT_FEEDERS_LIST: "/feeders",
  CONTENT_VALIDATOR_LIST: "/validators",
  PAYMENT_CLAIM_REQ: "/pay/claim/req",
  VALIDATE_QUES: "/validate/questions",
  SM_CAT: "/sm/categories",
  SM_CAT_CA: "/sm/cat/ca",
  CA_PDF_LIST: "/sm/ca/pdf/list",
  CA_PDF_ADD: "/sm/ca/pdf/add",
  CA_PDF_VIEW: "/sm/ca/pdf/view",
  CA_PDF_EDIT: "/sm/ca/pdf/edit",
  STORIES: "/stories",
  USERS_LIST: "/users",
  USERS_VIEW: "/user/details",
  USERS_ORDER_VIEW: "/user/order/details",
  ORDERS: "/orders",
  TEST_PREVIEW: "/exam/preview/:testid",
  RUN_TEST_PREVIEW: "/exam/preview/start/:testid",
};
export const ToastType = {
  ERROR: "error",
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
};
